import React, { FC } from 'react';
import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { LoaderWrapper, LoadingRectangle } from 'style/styled-components/reusable.css';
import { maxZIndex } from 'style/styled-components/cssGlobalVariables';
import { CardCircleLoading } from 'components/Cards/CardCircleLoading';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import { ChannelBundleLoading } from 'components/Cards/CardChannelLoading';
import { ImageAspectRatio, ModuleType } from 'types/Common';
import { CardLoading } from 'components/Cards/Card/CardLoading';
import { CardVariant } from 'components/Cards/Card/cardVariants';

export const TitlePlaceholder = styled.div`
    width: 120px;
    height: 16px;
`;

const StripeTitleLoadingRectangle = styled(LoadingRectangle)`
    border-radius: 100px;
`;

export const TilesPlaceholder = styled.div`
    white-space: nowrap;
    margin-top: 8px;
    margin-bottom: 12px;
`;

const InnerWrapper = styled.div`
    padding-top: 40px;
    padding-left: 16px;
    position: relative;
    z-index: ${maxZIndex};

    ${MQ(Breakpoints.s)} {
        padding-left: 32px;
    }

    ${MQ(Breakpoints.m)} {
        padding-left: 72px;
    }
`;

const loadingCardCount = 20;

export const StripeMixedLoadingUI: FC<{
    aspectRatio?: string;
    moduleType?: string;
    cardVariant?: CardVariant | null;
    withTitle: boolean;
}> = ({ aspectRatio, moduleType, cardVariant, withTitle }) => {
    const loadingCards = [];

    if (cardVariant) {
        loadingCards.push(<CardLoading key={'loading-banner'} variant={cardVariant} />);
    }

    for (let i = 0; !cardVariant && i < loadingCardCount; i += 1) {
        if (moduleType === ModuleType.CHANNEL || moduleType === ModuleType.TV_CHANNEL) {
            loadingCards.push(<ChannelBundleLoading key={`loading-${i}`} />);
            i += 1; // the bundle contains 2 channels
        } else if (aspectRatio === ImageAspectRatio.ROUNDED) {
            loadingCards.push(<CardCircleLoading key={`loading-${i}`} />);
        } else if (aspectRatio === ImageAspectRatio.PORTRAIT) {
            loadingCards.push(<CardLoading key={`loading-${i}`} variant={CardVariant.PORTRAIT} />);
        } else {
            loadingCards.push(<CardLoading key={`loading-${i}`} variant={CardVariant.LANDSCAPE} style={{ margin: 0, marginRight: 8 }} />);
        }
    }

    return (
        <LoaderWrapper>
            <InnerWrapper>
                {withTitle && (
                    <TitlePlaceholder>
                        <StripeTitleLoadingRectangle />
                    </TitlePlaceholder>
                )}
                <TilesPlaceholder>{loadingCards}</TilesPlaceholder>
            </InnerWrapper>
        </LoaderWrapper>
    );
};
